export default __webpack_public_path__ + "static/20-sitzer-1-b75ba8f6f0d96b75f9c489df12fb69b3.jpg";